// @flow
import {path} from 'ramda';

export const generateIdMapper =
  (propPath: string[], idKey?: string = 'id') =>
  (props: any) => {
    const list = path(propPath, props);
    return list ? list.map(item => item[idKey]) : undefined;
  };
